<template lang="pug">
  div
    div.panel-dashboard__legend_icon(@click='clickDatos')
      // ods-icon(name="list" size="22")
      img(src= '@/assets/images/icon/leyenda.svg')
    PopUpCrm(:datosLegend='datosLegend'
    v-if = 'open'
    @closePopUp='open = false'
    ref='PopUpCrm'
    :getdataPopUp='getdataPopUp')
</template>

<script>
import StatusCero from '@/components/StatusCero'
import PopUpCrm from '@/components/PopUpCrm'
export default {
  name: 'LegendIcon',
  data () {
    return {
      datosType: [],
      datosPopup: [],
      open: false
    }
  },
  props: {
    datosLegend: {
    }
  },
  computed: {

  },
  methods: {
    clickDatos () {
      this.open = !this.open
      console.log('valores de data getdataPopUp---------poPup', this.datosPopup, '----datosLegend-->', this.datosLegend)
    },
    getdataPopUp () {
      this.datosPopup = this.datosLegend
    }
  },
  components: {
    StatusCero,
    PopUpCrm
  },

  mounted () {
    // console.log(this.$refs.PopUpCrm);
    // console.log("datos---MapIconnnnn--->", this.datosLegend)
    // this.datosPopup = this.datosLegend
    this.getdataPopUp()
  }
}
</script>

<style lang="scss">
.panel-dashboard__legend_icon{
  position: absolute;
  left: 0px;
  bottom: 0px;
  z-index: 2;
  padding: 7px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/LegendMapIcon.vue